<template>
  <!-- Footer  -->
  <div class="footer">
    <div class="footer-heading">
      <a href="https://emennu.com" target="_blank">Emennu - {{ $t('SeuCardapioOnlineDigital') }}</a>
    </div>
  </div>
  <!-- .Footer  -->
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style></style>
